import { Copy, FileText } from "lucide-react";
import { useNotify } from "ra-core";
import { useState } from "react";

import type { GulaOrder } from "./gulaTypes";
import { copyInstallerParte, openInstallerParte } from "./installerNotify";

/** The installer's parte as a printable page (PDF) or as text for WhatsApp. */
export const InstallerParteLinks = ({ order }: { order: GulaOrder }) => {
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const run = async (action: () => Promise<void>, done?: string) => {
    setBusy(true);
    try {
      await action();
      if (done) notify(done, { type: "info" });
    } catch (error) {
      notify(
        error instanceof Error ? error.message : "No se ha podido preparar",
        { type: "error" },
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs">
      <button
        type="button"
        disabled={busy}
        onClick={() =>
          run(() => openInstallerParte(order.id, order.installer_id))
        }
        className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground hover:underline disabled:opacity-50"
      >
        <FileText className="h-3 w-3" />
        Parte (PDF)
      </button>
      <button
        type="button"
        disabled={busy}
        onClick={() =>
          run(
            () => copyInstallerParte(order.id, order.installer_id),
            "Parte copiado: pégalo en el WhatsApp del instalador",
          )
        }
        className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground hover:underline disabled:opacity-50"
      >
        <Copy className="h-3 w-3" />
        Copiar para WhatsApp
      </button>
    </div>
  );
};
